import { render } from "./AnnotationViewer.vue?vue&type=template&id=5ca985e8&scoped=true"
import script from "./AnnotationViewer.vue?vue&type=script&lang=js"
export * from "./AnnotationViewer.vue?vue&type=script&lang=js"

import "./AnnotationViewer.vue?vue&type=style&index=0&id=5ca985e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca985e8"]])

export default __exports__